import { Validator } from 'jsonschema';

// Import definitions and schema.
import definitions from '../../assets/schemas/definitions.schema.json';
import componentDefinitions from '../../assets/schemas/components.schema.json';
import actionDefinitions from '../../assets/schemas/actions.schema.json';
import schema from '../../assets/schemas/package.schema.json';

/**
 * Validates the package data based on the schemas.
 * @param  {object} packageData JSON data representing the package.
 * @return {ValidatorResult}            True if data is valid. False if not.
 */
export function validatePackageData(packageData) {
  const validator = new Validator();

  // Loop definitions and add them to the validator.
  definitions.definitions.forEach(def => {
    validator.addSchema(def, def.id);
  });
  componentDefinitions.definitions.forEach(def => {
    validator.addSchema(def, def.id);
  });
  actionDefinitions.definitions.forEach(def => {
    validator.addSchema(def, def.id);
  });

  // Validate data.
  return validator.validate(packageData, schema);
}



// WEBPACK FOOTER //
// ./src/utilities/api/validator.js